import { Page } from "../layout/Page";
import { Button } from "../ui/Button";
import { Section } from "../ui/Section";

export function NotFoundPage() {
  return (
    <Page title="Page not found" heading="We couldn't find that page">
      <Section eyebrow="404">
        <p className="max-w-xl text-ink-soft">
          The link may be from an older version of the site. Try the home page,
          or see what is coming up.
        </p>
        <div className="mt-6 flex gap-3">
          <Button href="/">Home</Button>
          <Button href="/events" variant="secondary">
            Events
          </Button>
        </div>
      </Section>
    </Page>
  );
}
